/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React from "react";
import { TabPanels } from "@carbon/react";

export default ({ children }) => {
  return <TabPanels>{children}</TabPanels>;
};
